/* Package JSON Import will be here */
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getTranslate } from "react-localize-redux";
import Img from "react-image";
import { push } from "connected-react-router";
import { Row, Col, Badge, Typography, Space, Tag, Checkbox, Button } from "antd";
import Slider from "react-slick";
import classNames from "classnames";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getCultureNumberFormat, errorToast } from "utilities/utils";
import placeholderImg from "assets/img/banner-placeholder.png";
import { ImageLoader } from "components/Spinner";
import QuantityCounter from "containers/orders/QuantityCounter";
import CaseQuantityCounter from "containers/orders/CaseQuantityCounter";
import { updateFavProductStatus } from "reducers/favouriteProducts";
import Constants from "utilities/appConstants";
import OfferRibbon from "components/reusable/OfferRibbon";
import TooltipComp from "components/reusable/TooltipComp";
import ExchangeOrderQtyCounter from "containers/orders/exchangeOrder/ExchangeOrderQtyCounter";
import ExchangeOrderCaseQtyCounter from "containers/orders/exchangeOrder/ExchangeOrderCaseQtyCounter";
import modalConfirmationHook from "hooks/modalConfirmationHook";
import GenerateComplaint from "containers/complaints/GenerateComplaint";
import ProductDetailsDrawer from "components/products/ProductDetailsDrawer";
/* Project Import will be here */

/* Const,Let & Var will be here */
const { Text } = Typography;
let isFavDisabled = false;
/* Const,Let & Var will be here */

class ProductItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentSelectionId: this.props.variants[0],
      popoverVisible: false,
      isShowGenerateComplaint: false,
      drawerVisible: false
    };
  }

  toggleDrawer = () => {
    this.setState((prevState) => ({
      drawerVisible: !prevState.drawerVisible,
    }));
  };

  menuPopoverHide = () => {
    this.setState({ popoverVisible: false });
  };

  menuPopoverHandleVisibleChange = popoverVisible => {
    this.setState({ popoverVisible });
  };

  componentDidUpdate = (prevProps) => {
    if (this.props.variants[0] !== prevProps.variants[0]) {
      this.setState({
        currentSelectionId: this.props.variants[0]
      });
    }
  }

  onVariantClick = (id) => {
    this.setState({ currentSelectionId: id });
  };

  getBadgeClass = (key) => {
    const { cart } = this.props;

    if (this.state.currentSelectionId === key)
      return "badge--gram badge-selected";
    else if (cart.data[key])
      return "badge--gram badge-active";
    else
      return "badge--gram";
  };

  /* add or remove the product from fav product */
  addOrRemoveFavProduct = (productInfo) => {
    if (!isFavDisabled)
      this.props.actions.updateFavProductStatus(productInfo, () => { isFavDisabled = false });

    isFavDisabled = true;
  };

  /* Get the exact product name row grid size based on the fav icon and past purchased icon */
  getProductNameSpanSize = (appSettings, product) => {
    let size = 24;

    /* Color code */
    const checkColorCode = (appSettings.isShowColorCode && product.Purchased !== undefined && product.Purchased !== 0);
    if (checkColorCode)
      size = size - 2;

    /* Fav product */
    if (appSettings.isFavProductEnable)
      size = size - 2;

    /* Complaint */
    if (appSettings.isEnableComplaints && product.IsSaleable && this.props.pageType !== Constants.SMART_LIST_PRODUCTS && this.props.pageType !== Constants.REDUCER_SUGGESTED_PRODUCTS && this.props.pageType !== Constants.REDUCER_REPEAT_MY_LAST_ORDER_PRODUCTS && this.props.pageType !== Constants.EXCHANGE_RETURN_PRODUCT_LIST)
      size = size - 3;

    /* SmartList checkbox */
    if (this.props.pageType === Constants.SMART_LIST_PRODUCTS || this.props.pageType === Constants.REDUCER_SUGGESTED_PRODUCTS || this.props.pageType === Constants.REDUCER_REPEAT_MY_LAST_ORDER_PRODUCTS)
      size = size - 2;

    return size;
  }

  openProductDetailsModal = (product) => {
    const { translate, pageType, check } = this.props;

    if ((pageType === Constants.SMART_LIST_PRODUCTS || pageType === Constants.REDUCER_SUGGESTED_PRODUCTS || pageType === Constants.REDUCER_REPEAT_MY_LAST_ORDER_PRODUCTS) && !check.includes(product.ProductId)) {
      errorToast({ content: translate("common.alerts.error.productSelectionDisabled") });
    }
    else {
      if (pageType !== Constants.SCHEME_DETAILS && pageType !== Constants.BANNER_DETAILS && pageType !== Constants.EXCHANGE_RETURN_PRODUCT_LIST)
        this.toggleDrawer();
    }
  }

  openGenerateComplaintDrawer = () => {
    /* Generate complaint confirmation modal */
    modalConfirmationHook(this.props.translate("common.alerts.confirmation.generateComplaintConfirmationTitle"),
      this.props.translate,
      (() => {
        this.setState({ isShowGenerateComplaint: true });
      }));
  }

  closeGenerateComplaintDrawer = () => {
    this.setState({ isShowGenerateComplaint: false });
  }

  render() {
    const { variants, products, translate, common, appSettings, pageType, check, onCheck } = this.props;
    const product = products[this.state.currentSelectionId];

    return (
      <div>
        {/* Product card for mobile view */}
        <div className="product-mobile-card" >
          <OfferRibbon product={product} pageType={pageType} translate={translate} >
            <div className="product-card-top">
              <Row className="w-100">
                <Col span={6}>
                  <div
                    className={classNames('product-img', {
                      'product-img-with-offer': product.DiscAmount > 0 || product.SchemeAmount > 0 || product.SchemeList.length > 0,
                      'cursor-default': (pageType === Constants.SCHEME_DETAILS) || (pageType === Constants.BANNER_DETAILS)
                    })}
                    onClick={(e) => { this.openProductDetailsModal(product) }}
                  >
                    <Img
                      alt=""
                      src={[product.ImageUrl, placeholderImg]}
                      loader={<ImageLoader />}
                    />
                  </div>

                  {/* SIH no stock error message */}
                  <div className="text-center h-22 ">
                    {appSettings.isShowSIHColorCode && product.SIH === 0 &&
                      <Tag className="round-radius mr-0 stockRedStyle font-6" color="#ff0000">{translate("products.productLabel.outOfStock")}</Tag>
                    }
                  </div>
                </Col>

                <Col span={18}>
                  <div className="product-card-content w-100">
                    <Row>
                      <Col
                        span={this.getProductNameSpanSize(appSettings, product)}
                        className={classNames({
                          'cursor-pointer': (pageType !== Constants.SCHEME_DETAILS && pageType !== Constants.BANNER_DETAILS)
                        })}
                      >
                        <TooltipComp title={product.ProductName}>
                          <h4 onClick={(e) => { this.openProductDetailsModal(product) }} className={appSettings.isEnableProductNameWordWrap ? "p-name-wrap-three-line" : "p-name-wrap-one-line"}>
                            {product.ProductName}
                          </h4>
                        </TooltipComp>
                      </Col>

                      {/* Color code icon */}
                      {(appSettings.isShowColorCode && product.Purchased !== undefined && product.Purchased !== 0) &&
                        <Col span={2} className="text-center mt-2">
                          <Badge status="processing" />
                        </Col>
                      }

                      {/* Fav product icon */}
                      {appSettings.isFavProductEnable &&
                        <Col span={2} className="text-center mt-2 ">
                          <div
                            onClick={() => { this.addOrRemoveFavProduct(product) }}
                          >
                            {product.IsFavourite ? (<i className="fa fa-heart fa-lg fav-product-icon-color" aria-hidden="true"></i>) : (<i className="fa fa-heart-o fa-lg" aria-hidden="true"></i>)}
                          </div>
                        </Col>
                      }

                      {/* Generate complaint icon */}
                      {(appSettings.isEnableComplaints && product.IsSaleable) && pageType !== Constants.SMART_LIST_PRODUCTS && pageType !== Constants.REDUCER_SUGGESTED_PRODUCTS && pageType !== Constants.REDUCER_REPEAT_MY_LAST_ORDER_PRODUCTS && pageType !== Constants.EXCHANGE_RETURN_PRODUCT_LIST && (
                        <Col span={3} className="text-center">
                          <TooltipComp title={translate("common.links.generateComplaint")}>
                            <Button
                              type="link"
                              icon={<i className="fa fa-exclamation-circle fa-lg complaint-product-icon" aria-hidden="true"></i>}
                              onClick={() => this.openGenerateComplaintDrawer()}
                              className="p-0"
                            >
                            </Button>
                          </TooltipComp>
                        </Col>
                      )}

                      {/* Smart list checkbox selection checkbox */}
                      {(pageType === Constants.SMART_LIST_PRODUCTS || pageType === Constants.REDUCER_SUGGESTED_PRODUCTS || pageType === Constants.REDUCER_REPEAT_MY_LAST_ORDER_PRODUCTS) &&
                        <Col span={2} className="d-flex mt-2 justify-content-center pr-1">
                          <span onClick={(e) => e.stopPropagation()}>
                            <Checkbox
                              onChange={(e) => onCheck(e, product.ProductId)}
                              checked={check.includes(product.ProductId)}
                            >
                            </Checkbox>
                          </span>
                        </Col>
                      }
                    </Row>

                    {/* Check for variant */}
                    {(products[variants[0]] && products[variants[0]].Variant) &&
                      <div className="product-quantity-block">
                        <Slider {...Constants.CAT_MENU_SLIDER_SETTINGS} className="variant-menu-slider">
                          {variants.map((key) => {
                            return (
                              <div key={key}>
                                {products[key] && products[key].Variant && (
                                  <React.Fragment>
                                    <span
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        this.onVariantClick(key);
                                      }}
                                      className={`${this.getBadgeClass(key)}`}
                                    >
                                      {products[key].Variant}
                                    </span>
                                  </React.Fragment>
                                )}
                              </div>
                            );
                          })}
                        </Slider>
                      </div>
                    }

                    <Row justify="left" className="pt-1 pb-1 cursor-default">
                      {appSettings.isEnableMRP && <Col span={12} md={10}>
                        <i className="fa fa-tag" aria-hidden="true"></i>
                        <span className="font-12">{` ${translate("products.productLabel.mrp")} : `}</span>
                        <span className="price-font">{getCultureNumberFormat(product.MRP.toFixed(2), true)}</span>
                      </Col>
                      }
                      {appSettings.isEnableSP &&
                        <Col span={appSettings.isEnableMRP ? 12 : 24} md={10}>
                          <i className="fa fa-tag" aria-hidden="true"></i>
                          <span className="font-12">{` ${translate("products.productLabel.ptr")} : `}</span>
                          <span className="price-font">{getCultureNumberFormat(product.SellPrice.toFixed(2), true)}</span>
                        </Col>
                      }
                    </Row>

                    {(appSettings.isShowStockQty || (appSettings.isEnablePlaceOrderCase && appSettings.isShowConversionQtyLabel) || (common.productTab === Constants.RELEVANT && appSettings.isEnableSO) || appSettings.isEnableMinOrderQty) &&
                      <Space size="middle" className="flex-wrap p-1">
                        {appSettings.isShowStockQty &&
                          <span>
                            <Badge color="orange" />
                            <Text className="font-12">{translate("products.productLabel.stockQty")} : {product.SIH}</Text>
                          </span>
                        }

                        {(appSettings.isEnablePlaceOrderCase && appSettings.isShowConversionQtyLabel) &&
                          <span>
                            <Badge color="orange" />
                            <Text className="font-12">{translate("products.productLabel.ConversionQtyCase")} : {product.ConversionQty}{translate("products.productLabel.unit")}</Text>
                          </span>
                        }

                        {(common.productTab === Constants.RELEVANT && appSettings.isEnableSO && product.SoQty > 0) &&
                          <span>
                            <TooltipComp title={translate("products.productLabel.productSoButtonHoverText", { qty: product.SoQty })}>
                              <Badge color="orange" />
                              <Button
                                className="product-card-add-so p-0"
                                size="small"
                                type="link"
                                onClick={() => this.props.addSpecificRelevantItemsToCart(product)}
                                disabled={appSettings.isRestrictSIHProducts && product.SIH === 0}
                                shape="round">{`${translate("common.buttons.addSo")} : ${product.SoQty}`}</Button>
                            </TooltipComp>
                          </span>
                        }

                        {(appSettings.isEnableMinOrderQty && product.MinORDQty > 0) &&
                          <span>
                            <Badge color="orange" />
                            <Text className="font-12">{translate("products.productLabel.minQty")} : {product.MinORDQty}</Text>
                          </span>
                        }
                      </Space>
                    }
                  </div>
                </Col>
              </Row>
            </div>
          </OfferRibbon>

          <Row className="product-footer" justify="start">
            {appSettings.isEnablePlaceOrderCase &&
              <Col span={12}>
                <div className="product-case">
                  {translate("products.productLabel.case")} :
                  <span className="ml-1">
                    {pageType === Constants.EXCHANGE_RETURN_PRODUCT_LIST ?
                      <ExchangeOrderCaseQtyCounter product={product} pageType={pageType} />
                      :
                      <CaseQuantityCounter
                        product={product}
                        isDisable={(pageType === Constants.SMART_LIST_PRODUCTS || pageType === Constants.REDUCER_SUGGESTED_PRODUCTS || pageType === Constants.REDUCER_REPEAT_MY_LAST_ORDER_PRODUCTS) ? !check.includes(product.ProductId) : false}
                      />
                    }
                  </span>
                </div>
              </Col>
            }
            {appSettings.isEnablePlaceOrderPiece &&
              <Col span={12} xs={!appSettings.isEnablePlaceOrderCase ? 24 : 12}>
                <div className="card-piece-text">
                  {translate("products.productLabel.piece")} :
                  <span className="ml-1">
                    {pageType === Constants.EXCHANGE_RETURN_PRODUCT_LIST ?
                      <ExchangeOrderQtyCounter product={product} pageType={pageType} />
                      :
                      <QuantityCounter
                        product={product}
                        isDisable={(pageType === Constants.SMART_LIST_PRODUCTS || pageType === Constants.REDUCER_SUGGESTED_PRODUCTS || pageType === Constants.REDUCER_REPEAT_MY_LAST_ORDER_PRODUCTS) ? !check.includes(product.ProductId) : false}
                      />
                    }
                  </span>
                </div>
              </Col>
            }
          </Row>

          {
            appSettings.isEnableComplaints && this.state.isShowGenerateComplaint &&
            <GenerateComplaint
              isShowGenerateComplaint={this.state.isShowGenerateComplaint}
              selectedSku={product}
              setIsShowGenerateComplaint={this.closeGenerateComplaintDrawer}
            />
          }
        </div>

        {/* Product details page drawer */}
        <ProductDetailsDrawer
          currentSelectionId={this.state.currentSelectionId}
          drawerVisible={this.state.drawerVisible}
          toggleDrawer={this.toggleDrawer}
          pageType={pageType}
        />
      </div >
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    localStore: state.localStore,
    translate: getTranslate(state.locale),
    router: state.router,
    appSettings: state.appSettings,
    common: state.common
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        updateFavProductStatus,
        push
      },
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductItem);